<script lang="ts" generics="ROW">
    import type {Column} from '@tanstack/svelte-table';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let column: Column<ROW>;

    const handleToggleColumnPin = () => {
        if (column.getIsPinned() !== false) {
            column.pin(false);
            return;
        }

        column.pin('left');
    };
</script>

<div class="kp-column-pinner" class:pinned={column.getIsPinned()}>
    <KpButton buttonStyle="no-background" buttonSize="xs" on:click={handleToggleColumnPin}>
        <UIcon icon="thumbtack" lineHeight="1"/>
    </KpButton>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    :global {
        .kp-column-pinner {
            position: absolute;
            display: flex;
            right: @spacing-sm;
            top: 50%;
            transform: translate(@spacing-xs, -50%);
            opacity: 0;
            z-index: 1;
            visibility: hidden;
            outline: none;
            background: none;
            color: @themed-text-muted-label;
            transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;

            &.pinned {
                transform: translate(0, -50%);
                color: var(--brand-orange);
                opacity: 1;
                visibility: visible;
            }

            .kp-button {
                display: flex;
                height: 24px;
                color: inherit;
            }
        }

        .kp-generic-grid-header-cell:hover .kp-column-pinner {
            transform: translate(0, -50%);
            opacity: 1;
            visibility: visible;
        }

        .kp-column-pinner {
            &.pinned .uicon {
                rotate: -45deg;
            }

            .uicon {
                transition: rotate 0.2s ease-in-out, color 0.2s ease-in-out;
            }
        }
    }
</style>